'use client';

import { useFeatureFlags } from '../../helpers/hooks/useFeatureFlags';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';

export const SupportChatLink = () => {
  const featureflags = useFeatureFlags(['zendesk']);
  const isZendeskEnabled = featureflags.zendesk;

  const SupportChatLink = isZendeskEnabled
    ? 'https://fishbrainhelp.zendesk.com/hc/en-us'
    : 'https://fishbrain.helpshift.com/a/fishbrain---social-fishing-forecast-app/';

  return (
    <ExternalLink href={SupportChatLink} variant="textDeprecatedLight" className="body-text-md">
      Support
    </ExternalLink>
  );
};
